export const PRODUCTS = [
  {
    title: 'Brands & products',
    text:
      'Delivering authenticity and high engagement through video reviews about products and brands shared by the shoppers',
    image: 'magic/ecosystem/brands-products.jpg',
    href: 'https://flip.shop/discover/trending/top-20-brands-today',
    id: 'brands-products',
  },
  {
    title: 'Community',
    text: 'Building trust and providing content scalability',
    image: 'magic/ecosystem/community.jpg',
    href: 'https://flip.shop/search/user?query=',
    id: 'community',
  },
  {
    title: 'The platform',
    text: 'Equipping buyers and sellers with premium ecommerce services',
    image: 'magic/ecosystem/platform.jpg',
    href: 'https://flip.shop/my-rewards',
    id: 'platform',
  },
]
